import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";
import { PRACTICE_SETTINGS_CONSULT_OUTCOMES } from "api/Service";

export const CONSULT_OUTCOMES_QUERY_KEY = "consultOutcomes";

export const useConsultOutcomes = () => {
  const tenantVal = localStorage.getItem("kinesin-tenant");

  return useQuery({
    queryKey: [CONSULT_OUTCOMES_QUERY_KEY, tenantVal],
    queryFn: async () => {
      const axiosInstance = createAxiosInstance();
      const response = await axiosInstance.get(
        `${tenantVal}${PRACTICE_SETTINGS_CONSULT_OUTCOMES}`
      );

      return Array.isArray(response.data) ? response.data : [];
    },
    enabled: !!tenantVal,
    staleTime: 5 * 60 * 1000,
  });
};
